import React from "react";

const CountyDropdown = ({ counties, selectedCounty, onChange }) => {
  return (
    <div className="mb-4">
      <label className="block text-sm font-medium mb-1">County:</label>
      <select className="w-full p-2 border rounded" value={selectedCounty} onChange={onChange}>
        <option value="">Select County</option>
        {counties.map((county) => (
          <option key={county} value={county}>{county}</option>
        ))}
      </select>
    </div>
  );
};

export default CountyDropdown;
